<template>
  <div class="v-404-page">
      <div class="flex-center">
          <h1>404</h1>
      </div>
  </div>
</template>
<script>
export default {
    name:"noFind404",
    components:{},
    data(){
        return{}
    }
}
</script>
<style lang="stylus" scoped>
.v-404-page{
    >div{
        min-height:80vh;
    }
}
</style>
